define('drops/frame/frame',[
    'jquery',
    'underscore',
    'lq/drop'
], function ($, _, Drop) {
	'use strict';

    var defaults = {
        data: {
            color: '#' + Math.floor(Math.random() * 16777215).toString(16),
            hasColor: true,
            hasScrollbars: false,
            opacity: 100
        }
    };

	var Frame = function (options) {
	    Drop.call(this, $('<div/>'), defaults, options);

	    // IE 8 messes up png files with transparency when we set the opacity, so only apply this style when really necessary
        if (this.data.opacity !== 100) {
            this.$element
                .css({ opacity: this.data.opacity / 100 });
	    }

	    this.renderDropShadow(this.data);
	    this.renderBackground(this.data);

        if (this.data.hasScrollbars) {
            this.$frameContainer = $('<div class="frame-container">')
                .appendTo(this.$element);
            this.$element.css({ overflow: "auto" });
        }
        else {
            this.$element.css({ overflow: "visible" });
        }

	    this.applyEventTrigger('mouseEnter', 'mouseenter');
	};

    Drop.extend(Frame, Drop);

    Frame.typeName = 'Frame';

    Frame.prototype.preRender = function () {
        this.piping.visibility.apply(this);
	    this.applyPosition();
	};

	Frame.prototype.render = function ($element) {
		return this.createAndRenderDrops($element);
	};


    Frame.prototype.postRender = function () {
        if (this.data.hasScrollbars) {
	        this.$element.css({ overflow: "auto" });

            this.switchBeetweenAnchorModes();

            this.$frameContainer.css({
                position: 'absolute',
                inset: '0px'
            })
            .appendTo(this.$element);
        }
	    else {
            this.$element.css({ overflow: "visible" });
        }
    };

    Frame.prototype.addAnchorContainer = function () {
        var sH = this.$element[0].scrollHeight;
        var sW = this.$element[0].scrollWidth;
        var self = this;
        if (!this.$frameContainer) {
            this.$frameContainer = $('<div class="frame-container">')
                .appendTo(this.$element);
        }
        _.each(this.$element.children(), function (child) {
            $(child).appendTo(self.$frameContainer)
        });
        this.$frameContainer.css({
                height: sH,
                width: sW,
                position: 'absolute',
                inset: '0px'
            })
            .appendTo(this.$element);
    };

    Frame.prototype.removeAnchorContainer = function () {
        if (this.$frameContainer) {
            var self = this;
            _.each(this.$frameContainer.children(), function (child) {
                $(child).appendTo(self.$element)
            });
            this.$frameContainer.remove();
        }
    };

    Frame.prototype.postWindowResize = function () {
        if (this.data.hasScrollbars) {
            this.switchBeetweenAnchorModes();
        }
    };

    Frame.prototype.createRenderPromiseForChild = function (drop) {
	    return drop.render(this.$frameContainer || this.$element);
	};

	Frame.prototype.renderBackground = function (data) {
        if (data.hasColor)
            this.$element.css({ backgroundColor: data.color });
        else
            this.$element.css({ backgroundColor: "transparent" });
	};

	Frame.prototype.renderDropShadow = function (data) {
	    if (data.hasDrop)
	        this.$element.css({ boxShadow: "rgb(136, 136, 136) " + data.dropSize + "px " + data.dropSize + "px " + data.dropBlur + "px" });
	    else
	        this.$element.css({ boxShadow: "" });
	};

	Frame.prototype.renderScrollbars = function (data) {
	    if (data.hasScrollbars) {
	        this.$element.css({ overflow: "auto" });
            this.addAnchorContainer();
        }
	    else {
	        this.$element.css({ overflow: "visible" });
            this.removeAnchorContainer();
        }
	};

    Frame.prototype.frameSizesCalculationHelper = function () {
        var sH = (this.$element[0].scrollHeight - this.$element[0].offsetHeight) <= 0 ? this.$element[0].offsetHeight : this.$element[0].scrollHeight;
        var sW = (this.$element[0].scrollWidth - this.$element[0].offsetWidth) <= 0 ? this.$element[0].offsetWidth : this.$element[0].scrollWidth;
        var hasVerticalScrollbar = this.$element[0].scrollHeight - this.$element[0].offsetHeight <= 0;
        var hasHorizontalScrollbar = this.$element[0].scrollWidth - this.$element[0].offsetWidth <= 0;

        return {
            sH: sH,
            sW: sW,
            hasVerticalScrollbar: hasVerticalScrollbar,
            hasHorizontalScrollbar: hasHorizontalScrollbar
        };
    };

    Frame.prototype.switchBeetweenAnchorModes = function () {
        var calcObject = this.frameSizesCalculationHelper();

        if (calcObject.hasVerticalScrollbar) {
            this.$frameContainer.css({
                top: 0,
                bottom: 0,
                height: ''
            });
        } else {
            this.$frameContainer.css({
                height: calcObject.sH,
                top: '',
                bottom: ''
            });
        }

        if (calcObject.hasHorizontalScrollbar) {
            this.$frameContainer.css({
                left: 0,
                right: 0,
                width: ''
            });
        } else {
            this.$frameContainer.css({
                width: calcObject.sW,
                left: '',
                right: ''
            });
        }
    }

	return Frame;
});


